import { IOrderFactory } from '../../entities/order/Order'
import { IProductResponse, transformProduct } from '../product/ProductTransformer'
import castListItems from '../castListItems'
import { parseDateTime } from '../../utils/parse-date'
import { OrderProductStatus } from '../../entities/order-product/OrderProduct'

type OrderProductStatusType = typeof OrderProductStatus
export interface IOrderResponse {
  'order_id':       number // 114,
  'status':         string // 'Open',
  'status_code':    OrderProductStatusType[keyof OrderProductStatusType] // 'O',
  'create_date':    string // '13/03/2022 23:00',
  'total':          number // 73,
  'store_id':       number // 36,
  'subtotal':       number // 40,
  'admin_note':     string // '',
  'customer_note':  string // '',
  'picking_hub_id': number // 0,
  'moved_to_in_progress': boolean // true
  'products':       IProductResponse[]
}

export const transformOrder = (order: IOrderResponse) : IOrderFactory => {
  return {
    orderId:      order.order_id,
    status:       order.status,
    statusCode:   order.status_code,
    adminNote:    order.admin_note,
    customerNote: order.customer_note,
    createDate:   parseDateTime(order.create_date),
    pickingHubId: order.picking_hub_id,
    storeId:      order.store_id,
    subtotal:     order.subtotal,
    total:        order.total,
    wasMovedToInProgress: order.moved_to_in_progress || false,
    products:     castListItems(order.products, transformProduct),
  }
}
